module.exports = __webpack_public_path__ + "img/alert.40e0b489.svg";